export const extraKeys = {
  DETAIL_ID_KEY: '_id',
  DOCUMENT_ID_KEY: '_documentId',
  ORDER_KEY: '_order',
  IS_BEING_EDITED: '_isBeingEdited',
  LAZY_DETAILS_WITH_ITEMS: '_lazyDetailsWithItems'
}

export const extraSuffix = '_ublique'

export const stagingKeys = {
  ADD: 'add',
  UPDATE: 'replace',
  DELETE: 'remove'
}

// Fields of these types do not exist in the document, and must be resolved/calculated,
// then removed when sending the document back to server
export const VIRTUAL_FIELDS = ['calculated', 'readonly']

// Fields with this property in their model config are always sent to the backend
export const INCLUDE_FIELD_KEY = 'sendToBackend'

// Linked documents in the following fields are saved as whole objects, not just uri's
export const PRESERVE_OBJECT_FIELDS = ['autocompletelinklazy', 'ubliquefulllink']
